import { ErrorBoundary } from 'react-error-boundary';
import { Routes, Route } from 'react-router-dom';
import { ShepherdTour } from 'react-shepherd';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { AccessControl } from '../../../components';
import { AtsAccess, useAtsAccess } from '../../../hooks/useAtsAccess';
import ErrorLogger from '../../../providers/ErrorLogger';
import RouteGuard from '../../../routes/RouteGuard';
import { tourOptions, submissionSteps } from '../../../utils/TourStepsAndOptions';
import StageStatusContextProvider from '../../submissions/context/StageStatusContext';
import SubmissionSettingContextProvider from '../../submissions/submissionListing/context/SubmissionSettingContext';
import Layout from '../components/Layout';

export const SubmissionsNewRoutes = () => {
  const isViewSubmission = useAtsAccess(AtsAccess.SUBMISSIONS);
  return (
    <Routes>
      <Route
        path="/"
        element={
          <RouteWithTitle title="Submitted Candidates- Wisestep">
            <RouteGuard>
              <StageStatusContextProvider>
                <SubmissionSettingContextProvider>
                  <ErrorBoundary FallbackComponent={({ error }) => <ErrorLogger error={error} />}>
                    <ShepherdTour steps={submissionSteps} tourOptions={tourOptions}>
                      {isViewSubmission ? <Layout /> : <AccessControl />}
                    </ShepherdTour>
                  </ErrorBoundary>
                </SubmissionSettingContextProvider>
              </StageStatusContextProvider>
            </RouteGuard>
          </RouteWithTitle>
        }
      />
    </Routes>
  );
};
